var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"c97db60d47687a3226a51ca2e350afd8ece0d3ca"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["blog-ui@kenzie-br"]={id:"c97db60d47687a3226a51ca2e350afd8ece0d3ca"};
      